import React from 'react';
import { Navigate } from 'react-router-dom';
import { canAny, isOwner, firstAllowedPath, can } from '../utils/permissions';
import Dashboard from '../pages/dashboard';

const Forbidden = () => (
  <div className="card">
    <h2>دسترسی ندارید</h2>
    <p className="empty">شما به این بخش دسترسی ندارید. با مدیر خود تماس بگیرید.</p>
  </div>
);

export default function RequirePermission({ perm, children }) {
  const list = Array.isArray(perm) ? perm : [perm];
  return canAny(...list) ? children : <Forbidden />;
}

export function OwnerOnly({ children }) {
  return isOwner() ? children : <Forbidden />;
}

export function DashboardHome() {
  if (can('dashboard.view')) return <Dashboard />;
  const p = firstAllowedPath();
  return p ? <Navigate to={p} replace /> : <Forbidden />;
}